mainApp.directive('linkHealth', ['$timeout', function($timeout){
    return {
        templateUrl: '/public/directives/charts/linkHealth.html',
        replace: true,
        scope: {
            options: '=?',
            item: '=',
            sampleCount: '=',
            innerSegmentsCount: '=?',
            currIndex: '=?',
            itemId: '=?',
        },
        link: function ($scope, el) {
            $scope.NA_HEALTH = "NA";

            $scope.options = $scope.options || {};
            $scope.innerOptions = {
                showTicks: true,
                fullDates: true,
                minimalData: true
            };

            $scope.startTime = null;
            $scope.endTime = null;

            $scope.healthPopupMessage = null;

            var topOffsetMod = $('#navbar-top').height();
            var windowWidth = $(window).width();
            var tickHeight, tickTop, leftOffset;
            var $elementJQ = $(el[0]);
            var mouseEnter;
            var $targetZoomEl;

            $scope.$watch('currIndex', function(newIndex){
                if(newIndex){
                    zoomHealth($elementJQ.find('[data-index="' + newIndex + '"]'));
                }
            });

			$scope.$watch('item', function(newVal, oldVal){
				if($scope.options.zoomEl && (!$targetZoomEl || $targetZoomEl.length === 0)){
					$targetZoomEl = $('#' + $scope.options.zoomEl);
					if($targetZoomEl.length === 1){
						$targetZoomEl.append($elementJQ.find('.health-popup'));
					}
				}

				$scope.innerOptions.width = 0;
				$scope.statsList = [];
				if($scope.item && $scope.item.rtStatsList && $scope.item.rtStatsList.length > 0){
					$scope.startTime = $scope.item.rtStatsList[0].sampleTime;
					$scope.endTime = $scope.item.rtStatsList[$scope.item.rtStatsList.length - 1].sampleTimeEnd;

                    $scope.statsList = processStats($scope.item.rtStatsList, $scope.options.width || ($elementJQ.width()), false, false);
                    getMiddleSampleTime();
				}
			});


			$scope.$watch('options.width', function(newVal, oldVal){
				reCalcWidth();
			});

            $scope.$watch('$root.menuClosed', function() {
                reCalcWidth();
            });

            function reCalcWidth() {
                $scope.innerOptions.width = 0;
                $scope.statsList = [];
                if($scope.item && $scope.item.rtStatsList && $scope.item.rtStatsList.length > 0){
                    $scope.startTime = $scope.item.rtStatsList[0].sampleTime;
                    $scope.endTime = $scope.item.rtStatsList[$scope.item.rtStatsList.length - 1].sampleTimeEnd;

                    $scope.statsList = processStats($scope.item.rtStatsList, $scope.options.width || ($elementJQ.width()), false, false);
                    getMiddleSampleTime();
                }
            }

            function setInnerWidth(){
                var $healthPopup = $elementJQ.find('.health-popup');
                $scope.innerOptions.width = $scope.innerWidth ? ($scope.innerWidth  / $scope.innerSegmentsCount) : (($scope.options.width? $scope.options.width : ($targetZoomEl? $targetZoomEl.width() : $healthPopup.find('.health-bar').width())) / ($scope.innerSegmentsCount));

                var popupWidth = $scope.innerWidth || $scope.options.width || $healthPopup.width();
				var elementWidth = $elementJQ.width();

                if(popupWidth && elementWidth && popupWidth > elementWidth){
                    $healthPopup.width(elementWidth);
                    popupWidth = elementWidth;
                }
                $scope.innerOptions.totalWidth = popupWidth;
            }

            function zoomHealth($tick){
                var $healthPopup = $elementJQ.find('.health-popup');

                if(((!$scope.statsList[$tick.data('index')] || $scope.statsList[$tick.data('index')].sampleCount === 0 || !$scope.statsList[$tick.data('index')].health
                    || $scope.statsList[$tick.data('index')].health.length === 0) && !$scope.options.showEmpty) || ($scope.statsList[$tick.data('index')] && !$scope.statsList[$tick.data('index')].zoomable)){
                    $scope.healthPopupMessage = null;
                    $tick.addClass('empty');
                    return;
                }

                $scope.healthPopupMessage = $scope.statsList[$tick.data('index')];
                $tick.removeClass('empty');
                if(!$scope.options.zoomEl){
                    $scope.innerHealthBarStats = [];
                }


                $timeout(function(){
                    mouseEnter = false;
                    if($scope.healthPopupMessage){
                        $scope.innerHealthBarStats = $scope.healthPopupMessage.health;
                        if($scope.options.zoomEl){
                            if(!$scope.innerOptions.width || !$scope.innerOptions.totalWidth){
                                setInnerWidth();
                            }
                        }
                        else {
                            var left;
                            var popupWidth = $healthPopup.width();
                            var elementWidth = $elementJQ.width();

                            if(popupWidth && popupWidth > elementWidth){
                                $healthPopup.width(elementWidth);
                                popupWidth = elementWidth;
                            }
                            $scope.innerOptions.width = ($healthPopup.find('.health-bar').width() / ($scope.innerSegmentsCount));
                            $scope.innerOptions.totalWidth = popupWidth;

                            if($scope.options.relative){
                                tickHeight = $tick.outerHeight();
                                tickTop = $tick.position().top + tickHeight;
                                leftOffset = $elementJQ.offset().left;
                                topOffsetMod = 0;
                            }
                            else {
                                if(!tickHeight){
                                    tickHeight = $tick.outerHeight();
                                    tickTop = $tick.offset().top + tickHeight;
                                    leftOffset = $elementJQ.offset().left - (document.getElementsByTagName('body')[0].className.indexOf('miniMenu') === -1 ? 245 : 110);
                                }
                            }


                            if($scope.options.fixedPopup){
                                left = (elementWidth / 2) - (popupWidth / 2);
                            }
                            else {
                                //left = ($scope.healthPopupMessage.width / 2 - (popupWidth / 2));
                                left = leftOffset;
                            }


                            if(left + popupWidth > windowWidth - 40){
                                left = windowWidth - popupWidth - 40;
                            }

                            if($scope.options.topMod){
                                tickTop += $scope.options.topMod;
                            }

                            $healthPopup.css({
                                left: Math.max(0, left),
                                top: (tickTop - topOffsetMod) + tickHeight - 5
                            });
                        }
                    }
                    $scope.$digest();
                }, 1, false);
            }

            $elementJQ.on("mouseenter", ".zoomable .health-bar-segment", function(event){
                if($scope.options.nozoom || $scope.options.noHoverZoom) {
                    return;
                }

                mouseEnter = true;
                event.stopPropagation();
                var $targetEl = $(event.currentTarget || event.target);

                zoomHealth($targetEl);
                if ($scope.options.hoverEvent) {
                    $scope.options.hoverEvent({ id: $scope.itemId, item: $scope.statsList[$targetEl.data('index')], el: $targetEl, index: $targetEl.data('index') });
                }
                $scope.$digest();
            });

            $elementJQ.delegate(".zoomable .health-bar-segment", "mouseleave", function(event){
                if(!$scope.options.zoomEl){
                    if(!mouseEnter){
                        $scope.healthPopupMessage = null;
                        if ($scope.options.hoverEvent) {
                            $scope.options.hoverEvent({id: $scope.itemId});
                        }
                    }
                    $scope.$digest();
                }
            });


            function processStats(statsList, widthMod, mergeDuplicates, noInner){
                if(!statsList || statsList.length === 0 || !statsList[0]){
                    return [];
                }

                //widthMod = widthMod - 25; // taking scrollbar into account

                var processedList = [];
                processedList.push(_.cloneDeep(statsList[0]));

                processedList[0].status = noInner? processedList[0].status : $scope.getStatus(processedList[0]);
                processedList[0].size = 1;

                for(var i=1;statsList[i];i++){
                    var currentItem = _.cloneDeep(statsList[i]);
                    currentItem.status = noInner? currentItem.status : $scope.getStatus(currentItem);

                    if(mergeDuplicates && isIdenticalStats(processedList[processedList.length - 1], currentItem, noInner)){
                        processedList[processedList.length - 1].size++;
                    }
                    else {
                        processedList[processedList.length - 1].width = (processedList[processedList.length - 1].size / statsList.length) * widthMod;
                        processedList[processedList.length - 1].sampleTimeEnd = currentItem.sampleTime;
                        processedList.push(currentItem);
                        processedList[processedList.length - 1].size = 1;
                        if($scope.options.showMiddleInZoom){
                            processedList[processedList.length - 1].sampleTimeMiddle = processedList[processedList.length - 1].sampleTime + parseInt((processedList[processedList.length - 1].sampleTimeEnd - processedList[processedList.length - 1].sampleTime) /2);
                        }
                    }
                }

                processedList[processedList.length - 1].width = (processedList[processedList.length - 1].size / statsList.length) * widthMod;
                processedList[processedList.length - 1].sampleTimeEnd = statsList[statsList.length - 1].sampleTimeEnd;
                if($scope.options.showMiddleInZoom){
                    processedList[processedList.length - 1].sampleTimeMiddle = processedList[processedList.length - 1].sampleTime + parseInt((processedList[processedList.length - 1].sampleTimeEnd - processedList[processedList.length - 1].sampleTime) /2);
                }

                return processedList;
            }

            function isIdenticalStats(prevItem, newItem, noInner){
                if(!noInner){
                    return(
                        (!newItem.health && !prevItem.health)
                        ||
                        (
                            (prevItem.health && newItem.health)
                            &&
                            (
                                prevItem.health.length === newItem.health.length
                                &&
                                (
                                    newItem.health.length === 0
                                    ||
                                    (
                                        newItem.health.length === 1
                                        &&
                                        (
                                            prevItem.health[0].status === newItem.health[0].status
                                            &&
                                            newItem.health[0].status === $scope.NA_HEALTH
                                            &&
                                            prevItem.sampleCount === newItem.sampleCount
                                            &&
                                            newItem.sampleCount === 0
                                        )
                                    )
                                )
                            )
                        )
                    )
                }
                else {
                    return(
                        prevItem.status.name === newItem.status.name
                    )
                }
            }

            $scope.isMiddle = function(index){
                return Math.floor(($scope.statsList.length/2)) === index;
            };

            $scope.clickEvent = function($event, item) {
                if ($scope.options.clickEvent) {
                    $scope.options.clickEvent($event, item);
                }
            };


            var resizeTimeout;

            function windowResize(){
                if (resizeTimeout) {
                    $timeout.cancel(resizeTimeout);
                }

                resizeTimeout = $timeout(function() {
                    windowWidth = $(window).width();
                    $scope.innerWidth = $elementJQ.width() - 5;
                    tickHeight = null;
                    tickTop = null;
                    leftOffset = null;
                    $scope.statsList = [];
                    setInnerWidth();
                    if($scope.item && $scope.item.rtStatsList && $scope.item.rtStatsList.length > 0){
                        $scope.statsList = processStats($scope.item.rtStatsList, $scope.innerWidth || $scope.options.width || ($elementJQ.width() - 10), false);
                        getMiddleSampleTime();
                    }

                    $scope.$digest();
                }, 0, false);

            }

            $(window).resize(windowResize);

            function getMiddleSampleTime(){
                switch($scope.item.rtStatsList.length){
                    case 0:
                        $scope.middleSampleTime = null;
                        break;
                    case 1:
                        $scope.middleSampleTime = ($scope.item.rtStatsList[0].sampleTime + $scope.item.rtStatsList[0].sampleTimeEnd) / 2;
                        break;
                    case 2:
                        $scope.middleSampleTime = ($scope.item.rtStatsList[0].sampleTime + $scope.item.rtStatsList[1].sampleTime) / 2;
                        break;
                    default:
                        $scope.middleSampleTime = $scope.item.rtStatsList[parseInt($scope.item.rtStatsList.length/2)].sampleTime;
                        break;
                }
            }

            function calculateStatuses(stats, segmentDuration){

                var health = stats.health;
                stats.statuses = [
                    {
                        duration: 0,
                        name: "NA"
                    },
                    {
                        duration: 0,
                        name: "HARD_LIMIT"
                    },
                    {
                        duration: 0,
                        name: "SOFT_LIMIT"
                    },
                    {
                        duration: 0,
                        name: "PASSIVE"
                    },
                    {
                        duration: 0,
                        name: ""
                    },
                ];


                for(var i=0;i<health.length;i++){
                    stats.statuses[health[i]].duration += segmentDuration;
                }

            }

            $scope.getStatus = function(stats){
                var i=0;
                if(!stats || !stats.health || stats.health.length === 0){
                    if($scope.options.showEmpty){
                        if(!stats || !stats.health){
                            stats = {
                                health: []
                            };
                        }
                        for(i=0;i<$scope.innerSegmentsCount;i++){
                            stats.health.push(0);
                        }
                        stats.zoomable = true;
                    }
                    else {
                        return;
                    }
                }
                $scope.innerSegmentsCount = stats.health.length;

                var segmentDuration = $scope.options.sampleDuration? $scope.options.sampleDuration : (stats.sampleTimeEnd - stats.sampleTime);

                calculateStatuses(stats, segmentDuration / stats.health.length);

                var foundNonOfflineStats = false;

                if ($scope.options.offlineOnlyIfAllOffline) {
                    for (i=0;i<stats.statuses.length;i++) {
                        if (stats.statuses[i].duration > 0 && i !== 0) {
                            foundNonOfflineStats = true;
                            break;
                        }
                    }
                }

                var healthStatus = stats.statuses[0];
                var currentStatsIsNa = true;

                for(i=1;i<stats.statuses.length;i++){
                    if(stats.statuses[i].duration > healthStatus.duration || (currentStatsIsNa && $scope.options.offlineOnlyIfAllOffline && foundNonOfflineStats)){
                        healthStatus = stats.statuses[i];
                        currentStatsIsNa = false;
                    }
                }

                stats.zoomable = $scope.options.showEmpty || !(healthStatus.duration < segmentDuration + 1 && healthStatus.duration > segmentDuration - 1);
                stats.eventIndication = eventIndication(healthStatus, stats.statuses, segmentDuration);
                return healthStatus;
            };

            function eventIndication(currentStatus, statsStatuses, segmentDuration){
                var eventIndication = '';
                var threshold = 1;
                //threshold = threshold - (threshold % MIN_STATS_DURATION) + MIN_STATS_DURATION;

                if(currentStatus.name !== statsStatuses[4].name && statsStatuses[4].duration > threshold){
                    eventIndication += '_ONLINE';
                }
                if(currentStatus.name !== statsStatuses[3].name && statsStatuses[3].duration > threshold){
                    eventIndication += '_PASSIVE';
                }
                if(currentStatus.name !== statsStatuses[0].name && statsStatuses[0].duration > threshold){
                    eventIndication += '_NA';
                }
                if(currentStatus.name !== statsStatuses[1].name && statsStatuses[1].duration > threshold){
                    eventIndication += '_HARD';
                }
                if(currentStatus.name !== statsStatuses[2].name && statsStatuses[2].duration > threshold){
                    eventIndication += '_SOFT';
                }

                return eventIndication;
            }

            $scope.$on('$destroy',function() {
                $(window).off('resize', windowResize);

                $elementJQ.off().find("*").off();
            });
        }
    }
}]);